<template>
  <div class="row">
    <div class="col mt-3">

        <!--
        <div class="container" @click="changeRoute('/auditor/covid-grant')">
          <div class="row outer-box-wrap">
            <div class="col-12 text-center text-bold font-size-15 bg-jeff-yellow-02 pt-4 pb-4">
              <div class="row">
                <div class="col">
                  <span class="text-jeff-yellow-03">$</span> Jefferson County COVID-19 Small Business/Non-Profit Emergency Relief Grant Program <span class="text-jeff-yellow-03">$</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        -->

      <!--
      <div class="row">  
        <div class="col">
          <link-box
          bg-color="primary-02"
          title-color="dark"
          title="Jefferson County COVID-19 Small Business/Non-Profit Emergency Relief Grant Program"
          icon="payment"
          icon-color="primary"
          title-align="center"
          route="coronavirus">
          </link-box>
        </div>
      </div>
      -->
      
      <!-- Top area with courthouse image ------------------------------------- -->
      <div class="row">
        <div class="col-md-6 order-1 order-md-0" style="padding: 15px 30px 0px 30px;">
          <div class="row">
            <div class="col bg-grey-01" style="min-height: 420px;">
                <div class="block-title text-dark mt-3 mb-3">
                <i class="material-icons" style="padding-right: 2px;">payment</i>
                Pay Property <span class="one-line">Taxes Online</span>
              </div>

              <div>
                <p>
                  To make a property tax payment online, click below and you will be re-directed to the Forte Payment Systems website.
                  They accept Visa, Master Card, American Express, and Discover Card.
                </p>
                <p>
                  To make a payment by telephone, call (877) 690-3729 using jurisdiction code 4577
                </p>

                <div>
                  <link-box
                  bg-color="dark"
                  dark="true"
                  title-color="light"
                  title="Make a Tax Payment"
                  title-align="left"
                  url="https://billpay.forte.net/JEFFERSONCOOHTAX/">
                  Click here to access the property tax payment site.
                  </link-box>
                  
                </div>
              </div>

              <div class="mt-3">
                <note-text note-id="35"></note-text>
              </div>
            </div>
          </div>
          
          <!--
          <text-box-title
          title="Pay Property"
          title2="Taxes Online"
          icon="payment"
          align="left"
          block="true"
          style="height: 100%;"
          title-bg="grey-01"
          class="mt-3 padding-bootstrap">
          -->


          <!-- </text-box-title> -->
        </div>

        <div class="col-md-6 mt-3 image-flex order-0 order-md-1">
          <img src="static/images/general/courthouse_front.jpg" alt="Jefferson County Courthouse" class="border-1 text-dark" />
        </div>
      </div>

      <!-- Second row --------------------------------------------------------- -->
      <div class="row">

        <div class="col-md-6 mt-3">

          <text-box-title
          title="Announcement: Title Office Holiday Hours"
          default="false"
          align="left"
          icon="assignment"
          icon-color="dark"
          title-bg="jeff-yellow"
          block="true"
          class="mt-3 padding-bootstrap">
            <div class="col">
              <p>The Steubenville and Rayland offices will be closed on
		Wednesday, November 11th in observance of Veteran's Day.</p>
            </div>
          </text-box-title>

          <link-box
          bg-color="jeff-yellow-02"
          icon="search"
          title-color="dark"
          title="Court Case Lookup &amp; Payments"
          title-align="left"
          class="mt-3"
          route="court/case-lookup-and-payments">
          Look up Jefferson County, Ohio court cases &amp; make payments here
          </link-box>

          <link-box
                title="Online GIS"
                title-color="dark"
                title-align="left"
                bg-color="primary-02"
                icon="language"
                class="mt-3"
                url="https://gis.jeffersoncountyoh.com">
            View County maps, plats, and images
          </link-box>

        </div>

        <div class="col-md-6" >

        <!--


            Copy Linkbox and do one just for text. Or, look at textbox


          -->

          <!--           
          <text-box-title
          title="Courthouse Closure"
          default="false"
          align="left"
          icon="warning"
          icon-color="danger"
          title-bg="warning-02"
          block="true"
          class="mt-3 padding-bootstrap">
            <div class="col">
				      Due to inclement weather, the Jefferson County Courthouse will be closed on Friday, February 4, 2022.
            </div>
          </text-box-title>
          -->

          <text-box-title
          title="Announcement: New Clerk of Courts Website"
          default="false"
          align="left"
          icon="assignment"
          icon-color="dark"
          title-bg="jeff-yellow"
          block="true"
          class="mt-3 padding-bootstrap">
            <div class="col">
              The Clerk of Courts is pleased to announce the launch of their
              new website, <a href="https://www.jeffersoncountyohcoc.com/" style="color: #0f568a;">jeffersoncountyohcoc.com</a>.
            </div>
          </text-box-title>

          <link-box
          class="mt-3"
          bg-color="primary-02"
          title-color="dark"
          title="Dog License / Dog Tags"
          icon="article"
          icon-color="dark"
          title-align="left"
          url="https://www.doglicenses.us/OH/Jefferson/">
            Click here to purchase dog licenses.<br />
          </link-box>
          
		  <!--
          <text-box-title
          title="Real Estate"
          title2="Legal Descriptions"
          icon="assignment"
          align="left"
          block="true"
          title-bg="grey-01"
          class="mt-3 padding-bootstrap">
          
            <div class="col">
              <div class="mb-3">
                <span class="text-bold">Real estate legal descriptions can be sent to:</span> <br />
                Jefferson County Mapping Department <br />
                301 Market Street <br />
                Steubenville, OH 43952
              </div>

              <div style="overflow: hidden;">
                or emailed: <a href="mailto:denise_mirabella@jeffersoncountyoh.com">denise_mirabella@jeffersoncountyoh.com</a>
              </div>
            </div>

          </text-box-title>
-->

          <text-box class="">
            <div class="col bg-grey-01 mt-3 p-3">
              <div class="text-dark font-size-15" style="font-weight: bold;">
                <i class="material-icons" style="padding-right: 2px;">assignment</i>
                Real Estate <span class="one-line">Legal Descriptions</span>
              </div>

              <div class="mb-3 mt-3">
                <span class="text-bold">Real estate legal descriptions can be sent to:</span> <br />
                Jefferson County Mapping Department <br />
                301 Market Street <br />
                Steubenville, OH 43952
              </div>

              <div style="overflow: hidden;">
                or emailed: <a href="mailto:denise_mirabella@jeffersoncountyoh.com" style="color: #0f568a;">denise_mirabella@jeffersoncountyoh.com</a>
              </div>
            </div>
          </text-box>
          
        </div>

      </div>

      <!-- GIS row ---------------------------------------------------------------- -->
      <div class="row">

        
        <div class="col-md-6">
        </div>

        </div> 
    
    </div> <!-- end main column -->
  </div>
</template>

<script>
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import TextBox from '@/components/layout/TextBox.vue'
import LinkBox from '@/components/layout/LinkBox.vue'
import NoteText from '@/components/display-utils/NoteText.vue'

export default {
  components: {
    TextBoxTitle,
    LinkBox,
    NoteText
  },
  data () {
    return {}
  },
  methods: {
    changeRoute: function(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
  .block-title {
    width: 100%;
    font-size: 1.5em;
    font-weight: bold;
    padding: 0;
    line-height: 1.5em;
  }

  .outer-box-wrap:hover {
  cursor: pointer;
  opacity: 0.8;
  }
</style>
